<div class="content">Authenticating...</div>

<sdk-loading [isLoading]="isLoading"></sdk-loading>
